import AsyncLoader from 'component/AsyncLoader';

export const Login =  AsyncLoader(() => import('./Login'));
export const RetrievePassword =  AsyncLoader(() => import('./RetrievePassword'));
export const Home =  AsyncLoader(() => import('./Home'));